export const RecordIcon = ({ fill = "#000" }) => {
  return (
    <svg
      width="20"
      height="28"
      viewBox="0 0 20 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3998 11.6004V14.0004C18.3998 18.6396 14.639 22.4004 9.99985 22.4004M1.59985 11.6004V14.0004C1.59985 18.6396 5.36066 22.4004 9.99985 22.4004M9.99985 22.4004V26.0004M5.19985 26.0004H14.7998M9.99985 17.6004C8.01162 17.6004 6.39985 15.9886 6.39985 14.0004V5.60037C6.39985 3.61214 8.01162 2.00037 9.99985 2.00037C11.9881 2.00037 13.5998 3.61214 13.5998 5.60037V14.0004C13.5998 15.9886 11.9881 17.6004 9.99985 17.6004Z"
        stroke="#80592B"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const WaveIcon = ({ size, fill }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 38 38" fill={fill}>
      <path
        d="M23.25 13.5833H26.5V24.4167H23.25V13.5833ZM17.8333 32H21.0833V6H17.8333V32ZM28.6667 10.3333V27.6667H31.9167V10.3333H28.6667ZM12.4167 26.5833H15.6667V11.4167H12.4167V26.5833ZM7 22.25H10.25V15.75H7V22.25Z"
        fill={fill}
      />
    </svg>
  );
};

export const RewindIcon = ({ ...props }) => {
  return (
    <svg
      {...props}
      cursor={"pointer"}
      width="90"
      height="40"
      viewBox="0 0 83 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="82" height="28" rx="14" fill="white" />
      <rect x="0.5" y="0.5" width="82" height="28" rx="14" stroke="#0B2057" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2036 10.6839C10.2174 10.5641 10.2583 10.4493 10.323 10.3485C10.3877 10.2478 10.4744 10.164 10.5763 10.1037C10.6781 10.0434 10.7923 10.0083 10.9097 10.0013C11.0271 9.99429 11.1445 10.0155 11.2525 10.0632C11.7986 10.3026 13.0223 10.8716 14.5751 11.7908C16.1285 12.7105 17.2211 13.5137 17.6957 13.8781C18.1008 14.1898 18.1019 14.8078 17.6962 15.1206C17.2262 15.4829 16.147 16.2755 14.5751 17.2068C13.0018 18.1381 11.7924 18.7003 11.2515 18.9365C10.7857 19.1406 10.2643 18.8311 10.2036 18.3158C10.1327 17.7136 10 16.3461 10 14.4993C10 12.6536 10.1321 11.2867 10.2036 10.6839Z"
        fill="#0B2057"
      />
      <path
        d="M24.3466 18.5H23.4466V10.556H27.2506C28.0586 10.556 28.7066 10.78 29.1946 11.228C29.6826 11.668 29.9266 12.272 29.9266 13.04C29.9266 14.032 29.5146 14.708 28.6906 15.068C28.4586 15.172 28.2306 15.248 28.0066 15.296L30.0946 18.5H29.0266L27.1066 15.452H24.3466V18.5ZM24.3466 14.6H27.0946C27.9426 14.6 28.5266 14.336 28.8466 13.808C28.9666 13.608 29.0266 13.352 29.0266 13.04C29.0266 12.536 28.8546 12.14 28.5106 11.852C28.1666 11.556 27.7106 11.408 27.1426 11.408H24.3466V14.6ZM31.2234 12.5H32.1234V18.5H31.2234V12.5ZM32.1594 10.316V11.492H31.1874V10.316H32.1594ZM38.3643 17.54C37.8843 18.244 37.1683 18.596 36.2163 18.596C35.3523 18.596 34.6483 18.296 34.1043 17.696C33.5763 17.104 33.3123 16.372 33.3123 15.5C33.3123 14.628 33.5763 13.896 34.1043 13.304C34.6483 12.704 35.3723 12.404 36.2763 12.404C37.1803 12.404 37.8763 12.76 38.3643 13.472V12.5H39.2643V18.5H38.3643V17.54ZM36.3363 17.78C36.9843 17.78 37.4963 17.556 37.8723 17.108C38.2323 16.684 38.4123 16.148 38.4123 15.5C38.4123 14.852 38.2323 14.316 37.8723 13.892C37.4963 13.444 36.9843 13.22 36.3363 13.22C35.6963 13.22 35.1763 13.444 34.7763 13.892C34.4003 14.316 34.2123 14.852 34.2123 15.5C34.2123 16.148 34.4003 16.684 34.7763 17.108C35.1763 17.556 35.6963 17.78 36.3363 17.78ZM44.349 14.108C44.269 13.484 43.765 13.172 42.837 13.172C41.917 13.172 41.457 13.46 41.457 14.036C41.457 14.276 41.553 14.46 41.745 14.588C41.945 14.708 42.193 14.808 42.489 14.888C42.785 14.968 43.105 15.044 43.449 15.116C43.801 15.18 44.125 15.276 44.421 15.404C44.717 15.524 44.961 15.692 45.153 15.908C45.353 16.124 45.453 16.42 45.453 16.796C45.453 17.38 45.233 17.828 44.793 18.14C44.353 18.444 43.757 18.596 43.005 18.596C42.205 18.596 41.569 18.396 41.097 17.996C40.665 17.644 40.433 17.184 40.401 16.616H41.337C41.393 17.168 41.705 17.54 42.273 17.732C42.481 17.796 42.685 17.828 42.885 17.828C43.093 17.828 43.285 17.816 43.461 17.792C43.637 17.768 43.809 17.724 43.977 17.66C44.361 17.508 44.553 17.248 44.553 16.88C44.553 16.632 44.453 16.444 44.253 16.316C44.061 16.18 43.817 16.072 43.521 15.992C43.225 15.904 42.901 15.828 42.549 15.764C42.205 15.692 41.885 15.596 41.589 15.476C41.293 15.356 41.045 15.192 40.845 14.984C40.653 14.776 40.557 14.488 40.557 14.12C40.557 13.576 40.753 13.156 41.145 12.86C41.545 12.556 42.133 12.404 42.909 12.404C43.645 12.404 44.225 12.58 44.649 12.932C45.001 13.228 45.205 13.62 45.261 14.108H44.349ZM49.3821 17.78C49.7661 17.78 50.1061 17.672 50.4021 17.456C50.6981 17.24 50.9141 16.96 51.0501 16.616H52.0221C51.8381 17.208 51.5021 17.684 51.0141 18.044C50.5021 18.412 49.8941 18.596 49.1901 18.596C48.3101 18.596 47.5941 18.296 47.0421 17.696C46.5061 17.112 46.2381 16.38 46.2381 15.5C46.2381 14.62 46.5061 13.888 47.0421 13.304C47.5941 12.704 48.3101 12.404 49.1901 12.404C49.8941 12.404 50.5021 12.588 51.0141 12.956C51.5021 13.316 51.8381 13.792 52.0221 14.384H51.0501C50.9141 14.04 50.6981 13.76 50.4021 13.544C50.1061 13.328 49.7661 13.22 49.3821 13.22C48.9981 13.22 48.6701 13.28 48.3981 13.4C48.1341 13.52 47.9101 13.684 47.7261 13.892C47.3341 14.324 47.1381 14.86 47.1381 15.5C47.1381 16.14 47.3341 16.676 47.7261 17.108C48.1261 17.556 48.6781 17.78 49.3821 17.78ZM55.7414 12.404C56.6374 12.404 57.3654 12.704 57.9254 13.304C58.4534 13.88 58.7174 14.612 58.7174 15.5C58.7174 16.388 58.4534 17.12 57.9254 17.696C57.3654 18.296 56.6374 18.596 55.7414 18.596C54.8454 18.596 54.1174 18.296 53.5574 17.696C53.0294 17.12 52.7654 16.388 52.7654 15.5C52.7654 14.612 53.0294 13.88 53.5574 13.304C54.1174 12.704 54.8454 12.404 55.7414 12.404ZM55.7414 17.78C56.3894 17.78 56.9014 17.556 57.2774 17.108C57.6374 16.684 57.8174 16.148 57.8174 15.5C57.8174 14.852 57.6374 14.316 57.2774 13.892C56.9014 13.444 56.3894 13.22 55.7414 13.22C55.0934 13.22 54.5814 13.444 54.2054 13.892C53.8454 14.316 53.6654 14.852 53.6654 15.5C53.6654 16.148 53.8454 16.684 54.2054 17.108C54.5814 17.556 55.0934 17.78 55.7414 17.78ZM60.8109 18.5H59.9109V10.1H60.8109V18.5ZM63.0198 18.5V13.292H61.7958V12.5H63.0198V10.352H63.9198V12.5H65.2998V13.292H63.9198V18.5H63.0198ZM70.8487 17.54C70.3687 18.244 69.6527 18.596 68.7007 18.596C67.8367 18.596 67.1327 18.296 66.5887 17.696C66.0607 17.104 65.7967 16.372 65.7967 15.5C65.7967 14.628 66.0607 13.896 66.5887 13.304C67.1327 12.704 67.8567 12.404 68.7607 12.404C69.6647 12.404 70.3607 12.76 70.8487 13.472V12.5H71.7487V18.5H70.8487V17.54ZM68.8207 17.78C69.4687 17.78 69.9807 17.556 70.3567 17.108C70.7167 16.684 70.8967 16.148 70.8967 15.5C70.8967 14.852 70.7167 14.316 70.3567 13.892C69.9807 13.444 69.4687 13.22 68.8207 13.22C68.1807 13.22 67.6607 13.444 67.2607 13.892C66.8847 14.316 66.6967 14.852 66.6967 15.5C66.6967 16.148 66.8847 16.684 67.2607 17.108C67.6607 17.556 68.1807 17.78 68.8207 17.78Z"
        fill="#0B2057"
      />
    </svg>
  );
};

export const SendIcon = ({ ...props }) => {
  return (
    <svg
      {...props}
      fill="#0C2057"
      height="20px"
      width="20px"
      viewBox="0 0 495.003 495.003"
    >
      <g id="XMLID_51_">
        <path
          id="XMLID_53_"
          d="M164.711,456.687c0,2.966,1.647,5.686,4.266,7.072c2.617,1.385,5.799,1.207,8.245-0.468l55.09-37.616
		l-67.6-32.22V456.687z"
        />
        <path
          id="XMLID_52_"
          d="M492.431,32.443c-1.513-1.395-3.466-2.125-5.44-2.125c-1.19,0-2.377,0.264-3.5,0.816L7.905,264.422
		c-4.861,2.389-7.937,7.353-7.904,12.783c0.033,5.423,3.161,10.353,8.057,12.689l125.342,59.724l250.62-205.99L164.455,364.414
		l156.145,74.4c1.918,0.919,4.012,1.376,6.084,1.376c1.768,0,3.519-0.322,5.186-0.977c3.637-1.438,6.527-4.318,7.97-7.956
		L494.436,41.257C495.66,38.188,494.862,34.679,492.431,32.443z"
        />
      </g>
    </svg>
  );
};

export const DoneIcon = ({ ...props }) => {
  return (
    <svg {...props} height="24" viewBox="0 -960 960 960" width="24">
      <path
        d="M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z"
        fill={"green"}
      />
    </svg>
  );
};

export const StopIcon = () => {
  return (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.59961 8.4C1.59961 6.15979 1.59961 5.03969 2.0325 4.18404C2.41328 3.43139 3.02088 2.81947 3.76821 2.43597C4.61781 2 5.72999 2 7.95437 2H19.0752C21.2996 2 22.4117 2 23.2613 2.43597C24.0087 2.81947 24.6163 3.43139 24.9971 4.18404C25.4299 5.03969 25.4299 6.15979 25.4299 8.4V19.6C25.4299 21.8402 25.4299 22.9603 24.9971 23.816C24.6163 24.5686 24.0087 25.1805 23.2613 25.564C22.4117 26 21.2996 26 19.0752 26H7.95436C5.72999 26 4.61781 26 3.76821 25.564C3.02088 25.1805 2.41328 24.5686 2.0325 23.816C1.59961 22.9603 1.59961 21.8402 1.59961 19.6V8.4Z"
        stroke="#8F3131"
        strokeWidth="2.65722"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
